import { RadioGroup, View, Card } from "@/components/ui";
import { ListHeading } from "@/components/shared/list-header";
import { SectionDurationRadio } from "./section-duration-radio";
import type { DurationOption } from "@/components/shared/service-radio-item/types";

export function SectionSelectDuration({
  selectedDuration,
  durationOptions,
  durationSubTitles,
  onSelectDuration,
}: {
  selectedDuration: number;
  durationOptions: DurationOption[];
  durationSubTitles: string[];
  onSelectDuration(item: DurationOption): void;
}) {
  return (
    <Card className="flex flex-col gap-4 border border-border bg-background-intermediate p-3">
      <ListHeading title="Cleaning Duration" />
      <RadioGroup
        value={String(selectedDuration)}
        onValueChange={(value) => {
          const opt = durationOptions.find((o) => o.value === value);
          if (opt) onSelectDuration(opt);
        }}
      >
        <View className="flex flex-col gap-4">
          {durationOptions.map((item, index) => (
            <SectionDurationRadio
              key={item.value}
              item={item}
              selected={String(item.duration) === String(selectedDuration)}
              subTitle={durationSubTitles[index]}
              onSelect={() => onSelectDuration(item)}
            />
          ))}
        </View>
      </RadioGroup>
    </Card>
  );
}
